
































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";

@Component
export default class DeactivateWarrantyActivation extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) hiddenCode: string;
  @Prop({ type: String, default: "" }) consumerName: string;

  spinShow: boolean = false;
  reasonId = "0";
  reasonOther = "";
  reasons = [];
  namespace = "warrantyActivation";

  visibleChange(value: boolean) {
    if (!value) {
      this.reset();
      this.$emit("input", value);
    } else {
      this.getReasons();
    }
  }
  async mounted() {}
  created() {
    this.getReasons();
  }
  reset() {
    this.reasonId = "0";
    this.reasonOther = "";
    this.reasons = [];
  }
  async getReasons() {
    this.$store
      .dispatch({
        type: `${this.namespace}/getDeactivateReasons`,
      })
      .then((result) => {
        var re = result;
        re.push({ code: "0", description: this.L("Other") });
        this.reasons = re;
      });
  }
  save() {
    if (_.isNil(this.reasonId) || +this.reasonId < 0) {
      Util.showNoticeErrorMsg(
        this,
        Util.L("Error.RequiredField0", undefined, this.L("Reason"))
      );
      return;
    }
    if (
      +this.reasonId === 0 &&
      (_.isNil(this.reasonOther) || _.isEmpty(this.reasonOther))
    ) {
      Util.showNoticeErrorMsg(
        this,
        Util.L("Error.RequiredField0", undefined, this.L("ReasonOther"))
      );
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.DeActivateWarranty"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: `${this.namespace}/deactive`,
            data: {
              hiddenCode: this.hiddenCode,
              reasonId: +this.reasonId,
              reasonOther: +this.reasonId > 0 ? null : this.reasonOther,
            },
          })
          .then(() => {
            Util.showSuccessMsg(this, "Success.DeActivateWarranty");
            (this.$refs.deactivateWarrantyActivationForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  cancel() {
    this.reset();
    (this.$refs.deactivateWarrantyActivationForm as any).resetFields();
    this.$emit("input", false);
  }
}
